import { Pipe, PipeTransform } from '@angular/core';
import { DocumentStatus } from '../../../shared/enums/document-status.enum';
import { Dokument } from '../../../shared/models/dokument';

@Pipe({
  name: 'hasDocumentToReceive',
  standalone: true,
})
export class HasDocumentToReceivePipe implements PipeTransform {
  transform(value: Dokument[]): boolean {
    return value.some(
      (document) => document.statusDokumentu === DocumentStatus.PRZY,
    );
  }
}
